'use client'

import { storyblokEditable } from '@storyblok/react/rsc'
import { usePathname } from 'next/navigation'
import { type FC } from 'react'

import { type StoryblokComponentProps } from '../../model'
import { storyAccessorIsAllFromCategoryPath } from '../../model/storyAccessors/storyAccessorIsAllFromCategoryPath'
import { type StoryblokAkeneoCategoryPageType } from '../../storyblok'
import { StoryblokComponentsRenderer } from '../StoryblokComponentsRenderer'

import { StoryblokCategoryHeader } from './components/StoryblokCategoryHeader'
import {
  StoryblokCategoryChipNavigation,
  StoryblokCategoryNavigationMobile,
} from './components/StoryblokCategoryNavigation'
import { StoryblokCategoryProductSearch } from './components/StoryblokCategoryProductSearch'

export const StoryblokAkeneoCategoryPage: FC<
  StoryblokComponentProps<StoryblokAkeneoCategoryPageType>
> = ({ blok }) => {
  const { body, title } = blok
  const pathname = usePathname()

  const isAllFromCategoryPath = storyAccessorIsAllFromCategoryPath(pathname)

  return (
    <main
      {...storyblokEditable(blok)}
      className="grid grid-cols-1 gap-3 py-4 desktop:gap-6 desktop:py-6"
      data-qa-id="category-page"
    >
      <StoryblokCategoryHeader title={title} />
      <StoryblokCategoryNavigationMobile />
      <StoryblokCategoryChipNavigation />
      {isAllFromCategoryPath ? (
        <section className="container">
          <StoryblokCategoryProductSearch />
        </section>
      ) : (
        <StoryblokComponentsRenderer bloks={body} />
      )}
    </main>
  )
}
